const messages = {
  nav: {
    home: 'Home',
    sobre: 'Sobre',
    blog: 'Blog',
    contato: 'Contato',
    pacotes: 'Pacotes',
    searchPlaceholder: 'O que voce esta procurando?',
    generalInfo: 'Informacoes Gerais',
    back: 'Voltar',
  },
  modal: {
    title: 'Trocar idioma',
    portugues: 'Portugues',
    english: 'Ingles',
    spanish: 'Espanhol',
    close: 'Fechar',
    selectLanguage: 'Selecione o idioma',
  },
  countdown: {
    days: 'Dias',
    hours: 'Hrs',
    minutes: 'Min',
    seconds: 'Seg',
  },
  footer: {
    institutional: 'Institucional',
    packages: 'Pacotes',
    policies: 'Politicas e Termos',
    home: 'Home',
    about: 'Sobre',
    blog: 'Blog',
    contact: 'Contato',
    whatsappAlt: 'Fale Conosco pelo WhatsApp',
  },
  home: {
    viewAll: 'Ver tudo',
    moreDetails: 'Mais detalhes',
    fromPrice: 'a partir de',
    consultPrice: 'a consultar',
    blogSection: 'Veja Nosso Blog',
  },
  product: {
    description: 'Descricao',
    details: 'Detalhes',
    included: 'O que esta incluso',
    hotels: 'Hoteis',
    videos: 'Videos',
    registration: 'Inscricao',
    date: 'Data',
    type: 'Tipo',
    distance: 'Distancia',
    country: 'Pais',
    buyThisPackage: 'Quero comprar este pacote',
    clickHere: 'Clique aqui',
    registrationText: 'Para fazer sua inscricao clique no botao abaixo',
  },
  products: {
    categories: 'Categorias',
    countries: 'Paises',
    distance: 'Distancia',
    period: 'Periodo',
    sortBy: 'Ordenar por',
    sortAZ: 'A-Z',
    sortZA: 'Z-A',
    sortHighPrice: 'Maior Valor',
    sortLowPrice: 'Menor Valor',
    packages: 'Pacotes',
  },
  months: {
    all: 'Todos',
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Marco',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  },
  breadcrumb: {
    about: 'Sobre',
    contact: 'Contato',
    blog: 'Blog',
    generalInfo: 'Informacoes Gerais',
    exchange: 'Cambio',
  },
  contact: {
    phone: 'Fone',
    email: 'Email',
    whatsapp: 'Whatsapp',
    sendContact: 'Enviar Contato',
    yourName: 'Seu nome',
    yourEmail: 'Seu e-mail',
    yourWhatsapp: 'Seu Whatsapp',
    yourMessage: 'Sua mensagem',
  },
  blog: {
    latestNews: 'Ultimas Noticias',
    back: 'Voltar',
    share: 'Compartilhar',
  },
  info: {
    policiesTerms: 'Politica e Termos',
  },
  callAction: {
    downloadCalendar: 'Baixar Calendario',
  },
  exchange: {
    title: 'Acompanhe cotacoes de cambio',
  },
  common: {
    select: 'Selecione',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    searchKeywordRequired: 'Digite uma palavra chave para pesquisa.',
    nameRequired: 'Nome Obrigatorio.',
    emailRequired: 'E-mail Obrigatorio.',
    emailSentSuccess: 'E-mail enviado com sucesso.',
  },
  errors: {
    unauthorized: 'Acesso nao autorizado.',
    offline: 'Sistema fora do ar.',
    connectionFailed: 'Falha ao conectar, contate o administrador.',
  },
};

export function t(path) {
  return path.split('.').reduce((value, key) => value?.[key], messages) || path;
}

export function resolveLocaleField(item, field, defaultValue = '') {
  if (!item || !field) return defaultValue;
  return item[field] !== undefined && item[field] !== null && item[field] !== '' ? item[field] : defaultValue;
}
